import { STORE_PREFIX } from "../../constants";

export const createReduxNameSpace = (namespace: string): string =>
  `${STORE_PREFIX}/${namespace}`;

export default { createReduxNameSpace };
